<template>
	<div
		v-if="currentPage"
		class="page-wrapper-sizer content-padding"
		:class="['header-type--' + currentPage.type, { 'is-archive': isArchive }]"
	>
		<div class="page-header container" :class="showFeaturedImage ? 'has-image' : 'no-image'">
			<div class="header-info container container--a">
				<div class="inner-container">
					<GoUpButton :is-archive="isArchive" />
					<h1 class="page-title t-600">{{ currentPage.title }}</h1>
					<div
						v-if="pageExcerpt"
						class="content-excerpt page-excerpt font-size--26"
						v-html="pageExcerpt()"
					></div>
					<div v-if="isArchive" class="filters-area margin-top-lg">
						<div class="filters-row" v-if="currentPostType === 'post'">
							<select
								class="filter-posts filter-item styled-select"
								v-model="filters.category"
								name="post-category"
								:disabled="!storedTaxonomy('category').length"
							>
								<option value="">
									<template v-if="!filters.category">Filter by category</template>
									<template v-else>-- Clear --</template>
								</option>
								<template v-if="storedTaxonomy('category').length">
									<option
										v-for="{ name, id } in storedTaxonomy('category')"
										:key="id"
										:value="id"
										v-html="name"
									></option>
								</template>
							</select>
							<Button
								button
								class="filter-item newsletter-singup"
								@click.native="newsletterSingup"
								theme="light"
								icon="envelop"
								v-if="footerOpt.singup_posts && footerOpt.nesletter_form"
							>
								Sign up for newsletter
							</Button>
						</div>

						<div class="filters-row" v-if="currentPostType === 'events'">
							<select
								class="filter-item styled-select"
								v-model="filters.event_color_category"
								name="event-category-color"
							>
								<option value="">
									<template v-if="!filters.event_color_category">Category</template>
									<template v-else>-- Clear --</template>
								</option>
								<option value="default">Default</option>
								<option value="green">Green</option>
								<option value="red">Red</option>
								<option value="blue">Blue</option>
								<option value="purple">Purple</option>
							</select>
							<select
								class="filter-item styled-select"
								v-model="filters.event_category"
								name="event-category"
								:disabled="!storedTaxonomy('event_category').length"
							>
								<option value="">
									<template v-if="!filters.event_category">Type</template>
									<template v-else>-- Clear --</template>
								</option>
								<template v-if="storedTaxonomy('event_category').length">
									<option
										v-for="{ name, id } in storedTaxonomy('event_category')"
										:key="id"
										:value="id"
										v-html="name"
									></option>
								</template>
							</select>

							<Button
								class="filter-item"
								theme="light"
								button
								@click.native="filters.internal_only = !filters.internal_only"
								:icon="!filters.internal_only ? 'circle' : 'check'"
							>
								Only our events
							</Button>
							<Button
								class="filter-item"
								theme="light"
								button
								@click.native="filters.past_events = !filters.past_events"
								:icon="!filters.past_events ? 'circle' : 'check'"
							>
								Past events
							</Button>
						</div>
					</div>
				</div>
			</div>
			<EventDateMeta v-if="isEvent" />
			<div
				v-if="showFeaturedImage"
				:class="'type-' + currentPostType"
				class="post-img-hold spacer-padding-right--medium"
			>
				<WpImage
					:image="currentPage.featured_image"
					size="extra_large"
					class="featured-image-page"
					background
					cover
				/>
			</div>
		</div>
		<div class="container">
			<div
				v-if="showFeaturedImage && currentPage.featured_image.caption"
				:class="'type-' + currentPostType"
				class="page-img-caption spacer-padding-right--medium"
			>
				<div class="inner">
					{{ currentPage.featured_image.caption }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import WpImage from '@/components/elements/WpImage'
import GoUpButton from '@/components/parts/GoUpButton'
import Button from '@/components/elements/Button'
import EventDateMeta from '@/components/parts/EventDateMeta'
import _debounce from 'lodash.debounce'
import _isEqual from 'lodash.isequal'

export default {
	name: 'page-header',
	data() {
		return {
			filters: {
				category: '',
				event_category: '',
				event_color_category: '',
				internal_only: false,
				past_events: false,
			},
		}
	},
	watch: {
		'filters.event_category': function (value) {
			this.emitUpdateFilter(value, 'event_category')
		},
		'filters.event_color_category': function (value) {
			this.emitUpdateFilter(value, 'event_color_category')
		},
		'filters.internal_only': function (value) {
			this.emitUpdateFilter(value, 'internal_only')
		},
		'filters.past_events': function (value) {
			this.emitUpdateFilter(value, 'past_events')
		},
		'filters.category': function (value) {
			this.emitUpdateFilter(value, 'category')
		},
	},
	props: {
		isArchive: {
			type: Boolean,
			default: false,
		},
		isEvent: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		WpImage,
		GoUpButton,
		EventDateMeta,
		Button,
	},
	computed: {
		...mapGetters([
			'currentPageID',
			'currentPage',
			'currentPostType',
			'isTaxonomiesLoaded',
			'storedTaxonomyBySlug',
			'storedTaxonomy',
			'getOptions',
		]),
		footerOpt() {
			const { footer } = this.getOptions
			return footer || false
		},
		showFeaturedImage() {
			return this.currentPage && this.currentPage.featured_image && !this.isEvent && !this.isArchive
		},
	},
	methods: {
		...mapMutations(['NEWSLETTER_MODAL_CHANGE_STATE']),
		newsletterSingup() {
			this.NEWSLETTER_MODAL_CHANGE_STATE()
		},
		emitUpdateFilter(value, taxonomy) {
			this.$emit('onArchiveFilterUpdate', { action: taxonomy, value })
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
body {
	&.theme-default .type-events {
		.header-info {
			background-color: var(--dark) !important;
			color: #fff;
			.slide-hover:after {
				background-color: #fff;
			}
			.back-link {
				path {
					fill: #fff;
				}
			}
		}
		.page-header {
			&:after {
				background-color: var(--dark) !important;
			}
		}
		.post-img-hold .image {
			background-color: var(--dark) !important;
		}
	}
	&.theme-dark {
		.header-info {
			background-color: var(--dark) !important;
			color: #fff;
			.slide-hover:after {
				background-color: #fff;
			}
		}

		.page-header {
			&:after {
				background-color: var(--dark) !important;
			}
		}
		.post-img-hold .image {
			background-color: var(--dark) !important;
		}
	}
	&.theme-blue {
		.header-info {
			background-color: var(--blue) !important;
			color: #fff;
			.slide-hover:after {
				background-color: #fff;
			}
		}
		.page-header {
			&:after {
				background-color: var(--blue) !important;
			}
		}
		.post-img-hold .image {
			background-color: var(--blue) !important;
		}
	}
	&.theme-green {
		.header-info {
			background-color: var(--green) !important;
			color: #fff;
			.slide-hover:after {
				background-color: #fff;
			}
		}
		.page-header {
			&:after {
				background-color: var(--green) !important;
			}
		}
		.post-img-hold .image {
			background-color: var(--green) !important;
		}
	}
	&.theme-red {
		.header-info {
			background-color: var(--red) !important;
			color: #fff;
			.slide-hover:after {
				background-color: #fff;
			}
		}
		.page-header {
			&:after {
				background-color: var(--red) !important;
			}
		}
		.post-img-hold .image {
			background-color: var(--red) !important;
		}
	}
	&.theme-purple {
		.header-info {
			background-color: var(--purple) !important;
			color: #fff;
			.slide-hover:after {
				background-color: #fff;
			}
		}
		.page-header {
			&:after {
				background-color: var(--purple) !important;
			}
		}
		.post-img-hold .image {
			background-color: var(--purple) !important;
		}
	}
}
.single.page,
.single.event {
	overflow-x: hidden;
	.page-img-caption {
		@include fluid-type($smallResText, $wideResText, 14px, 16px);
		padding: 0;
		max-width: 850px;
		margin-left: auto;
		margin-right: auto;
		.inner {
			margin-top: 25px;
			padding-left: 25px;
			padding-right: 25px;
			max-width: 950px;
			margin-left: auto;
			margin-right: auto;
		}
		@include mquery($tablet) {
			padding-right: 0;
		}
		@include mquery($phone) {
			.inner {
				padding: 0;
				margin-top: 15px;
			}
		}
	}
	.filters-row {
		display: flex;
		@include mquery($phone) {
			flex-direction: column;
			.filter-posts {
				order: 1;
			}
		}
		.txt {
			white-space: nowrap;
		}
		.filter-item {
			margin-right: 25px;
			@include mquery($tablet) {
				margin-right: 15px;
			}
			@include mquery($phone) {
				margin-right: 0px;
				margin-bottom: 15px;
			}

			&:last-child {
				margin-right: 0;
				//margin-bottom: 0;
			}
		}
	}
	.page-wrapper-sizer {
		&.is-archive .header-info {
			padding-bottom: 50px;
			@include mquery($tablet) {
				padding-bottom: 40px;
			}
			@include mquery($phone) {
				padding-bottom: 30px;
			}
		}
		&.header-type--events {
			.header-info {
				border-bottom-left-radius: 0 !important;
				padding-bottom: 50px !important;
			}
			.page-header {
				&:after {
					bottom: 100px !important;
				}
			}
		}
	}
	.post-img-hold {
		@include mquery($tablet) {
			padding-right: 0;
			div.image {
				border-top-left-radius: 0;
			}
		}
	}
	.post-img-hold,
	.header-info {
		position: relative;
		z-index: 10;
	}
	.post-img-hold .image {
		background-color: var(--gray);
	}
	.page-header {
		position: relative;
		padding: 0;
		.header-info {
			padding: 75px;
			background-color: var(--gray);
			border-top-left-radius: $radius;
			@include mquery($tablet) {
				padding: 50px;
			}
			@include mquery($phone) {
				padding: 30px;
				padding-right: 0;
			}
		}
		&:after {
			content: '';
			background-color: var(--gray);
			position: absolute;
			top: 0;
			width: 50vw;
			left: 50%;
			bottom: 80px;
			z-index: -1;
			@include mquery($tablet) {
				left: 0;
				width: 100vw;
				bottom: 50px;
				border-top-left-radius: $radius;
				border-bottom-left-radius: $radius;
			}
		}

		&.no-image {
			.header-info {
				border-bottom-left-radius: $radius;
			}
			&:after {
				bottom: 0;
			}
		}
	}
}
</style>
